// Preloaded animated stickers & GIFs — Google Noto Animated Emoji.
// Served from Google's public CDN (no API key, free, animated + transparent).
const NOTO = "https://fonts.gstatic.com/s/e/notoemoji/latest";
export const stickerWebp = (cp) => `${NOTO}/${cp}/512.webp`; // transparent animated sticker
export const stickerGif = (cp) => `${NOTO}/${cp}/512.gif`;   // animated gif

export const STICKER_PACKS = [
  {
    key: "reactions",
    label: "⭐ Reactions",
    items: ["1f44d", "2764_fe0f", "1f602", "1f62d", "1f525", "1f44f", "1f64f", "1f389", "1f60d", "1f621", "1f44e", "1f97a"],
  },
  {
    key: "smileys",
    label: "😀 Smileys",
    items: ["1f600", "1f603", "1f604", "1f601", "1f606", "1f605", "1f923", "1f602", "1f642", "1f609",
            "1f60a", "1f60d", "1f970", "1f618", "1f61c", "1f61d", "1f92a", "1f60e", "1f914", "1f610",
            "1f636", "1f644", "1f60f", "1f62c", "1f925", "1f60c", "1f614", "1f62a", "1f634", "1f637",
            "1f912", "1f915", "1f922", "1f92e", "1f927", "1f975", "1f976", "1f635", "1f92f", "1f920",
            "1f973", "1f60b", "1f61b", "1f924", "1f97a", "1f929", "1f632", "1f62e", "1f910", "1f611"],
  },
  {
    key: "love",
    label: "❤️ Love",
    items: ["2764_fe0f", "1f9e1", "1f49b", "1f49a", "1f499", "1f49c", "1f5a4", "1f90d", "1f90e", "1f494",
            "2763_fe0f", "1f495", "1f49e", "1f493", "1f497", "1f496", "1f498", "1f49d", "1f48b", "1f48c"],
  },
  {
    key: "hands",
    label: "👍 Hands",
    items: ["1f44d", "1f44e", "1f44b", "1f44f", "1f64c", "1f450", "1f91d", "1f64f", "270c_fe0f", "1f91e",
            "1f918", "1f919", "1f44c", "1f90f", "270a", "1f44a", "1f4aa", "1f91b", "1f91c", "261d_fe0f",
            "1f596", "1f590_fe0f", "1f9b5"],
  },
  {
    key: "party",
    label: "🎉 Party",
    items: ["1f389", "1f38a", "1f388", "1f381", "1f382", "2728", "1f386", "1f947", "1f3c6", "1f451",
            "1f37e", "1f942", "1f37b", "1f52e"],
  },
  {
    key: "sad",
    label: "😢 Sad",
    items: ["1f62d", "1f622", "1f625", "1f613", "1f61e", "1f616", "1f623", "1f629", "1f62b", "1f971",
            "1f624", "1f621", "1f620", "1f92c", "1f631", "1f628", "1f630", "1f61f", "1f97a", "1f614"],
  },
  {
    key: "animals",
    label: "🐼 Animals",
    items: ["1f431", "1f98a", "1f43b", "1f43c", "1f981", "1f438", "1f427", "1f426", "1f984", "1f41d",
            "1f98b", "1f422", "1f419", "1f987", "1f43e"],
  },
  {
    key: "nature",
    label: "🔥 Nature",
    items: ["1f525", "1f4a5", "1f4ab", "2b50", "1f31f", "26a1", "1f308", "2744_fe0f", "1f30a", "1f4a7",
            "2601_fe0f", "1f337", "1f339", "1f340", "1f31e"],
  },
  {
    key: "food",
    label: "🍕 Food",
    items: ["1f355", "1f354", "1f32d", "1f369", "1f36a", "1f366", "1f382", "1f34e", "2615", "1f37b",
            "1f347", "1f349", "1f353", "1f373", "1f37f", "1f95e"],
  },
];
